module.exports = __webpack_public_path__ + "img/ic_16_fitnessplan-success.c30283a1.svg";